import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect, useState } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
import { UserProvider } from './context/UserContext';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { profileAdmin } from './api/service';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <UserProvider>
            <ScrollToTop />
            <StyledChart />
            <Router />
          </UserProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
